module.exports = __webpack_public_path__ + "bq.svg?559038bc1b2e0b64bf6190bdbd4b41bb";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bq.svg
// module id = 1012
// module chunks = 27